.e{flex-shrink:0;}